// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PJoy","colBig":"styles_colBig__3_r25","colSmall":"styles_colSmall__24J6V"};